// client/src/components/EftPaymentDetails.js
import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { formatCurrency } from '../utils/currency';

// What a customer needs to pay an order by EFT.
const EftPaymentDetails = ({ seller, reference, amount }) => {
  const hasBankDetails = Boolean(seller?.bank_name && seller?.bank_account_number);
  const rows = [
    ['Bank', seller?.bank_name],
    ['Account name', seller?.bank_account_name || seller?.company],
    ['Account number', seller?.bank_account_number],
    ['Branch code', seller?.bank_branch_code],
    ['Account type', seller?.bank_account_type],
    ['Amount', formatCurrency(amount)],
    ['Payment reference', reference],
  ].filter(([, value]) => value);
  const note = seller?.payment_instructions
    || (seller?.email ? `Please send your proof of payment to ${seller.email}.` : 'Please send us your proof of payment.');

  return (
    <Card sx={{ mb: 3, borderColor: 'primary.main' }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5, color: 'primary.main' }}>
          <AccountBalanceOutlinedIcon />
          <Typography variant="h6" color="inherit">Pay by EFT</Typography>
        </Stack>
        {hasBankDetails ? (
          <Box component="dl" sx={{ m: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 3, rowGap: 0.5 }}>
            {rows.map(([label, value]) => (
              <React.Fragment key={label}>
                <Typography component="dt" variant="body2" color="text.secondary">{label}</Typography>
                <Typography component="dd" variant="body2" fontWeight={700} sx={{ m: 0, overflowWrap: 'anywhere' }}>{value}</Typography>
              </React.Fragment>
            ))}
          </Box>
        ) : (
          <Typography variant="body2">
            Please contact us{seller?.email ? ` at ${seller.email}` : ''} for our banking details, and use <strong>{reference}</strong> as your payment reference.
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>{note}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          We start on your order once your payment has reflected in our account.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EftPaymentDetails;
